<form [formGroup]="informatieRapportageFg">
  <div>
    <ng-container formGroupName="titleOfTheDocument">
      <snelstart-ui-text-form-control formControlName="value"
                                      class="me-1 custom-input-250"
                                      label="Titel van de rapportage"
                                      (change)="saveForm()"
      >
      </snelstart-ui-text-form-control>
    </ng-container>
  </div>
  <div>
    <ng-container formGroupName="financialReportingPeriodCurrentStartDate">
      <snelstart-ui-date-form-control formControlName="value"
                                      class="me-1 custom-input-250"
                                      label="Startdatum rapportageperiode"
                                      (change)="saveForm()"
      >
      </snelstart-ui-date-form-control>
    </ng-container>
  </div>
  <div>
    <ng-container formGroupName="financialReportingPeriodCurrentEndDate">
      <snelstart-ui-date-form-control formControlName="value"
                                      class="me-1 custom-input-250"
                                      label="Einddatum rapportageperiode"
                                      (change)="saveForm()"
      >
      </snelstart-ui-date-form-control>
    </ng-container>
  </div>
  <div>
    <ng-container formGroupName="financialReportingPeriodDifferentThanAnnualStatus">
      <snelstart-ui-select-form-control formControlName="value"
                                        class="me-1 custom-input-250"
                                        label="Rapportageperiode afwijkend van jaar"
                                        [options]="optionsJaNee"
                                        [disabledControl]="false"
                                        (change)="bepaalAfwijkendRapportageJaar(); saveForm()"
      >
      </snelstart-ui-select-form-control>
    </ng-container>
  </div>
  @if (heeftAfwijkendRapportageJaar) {
    <div>
      <ng-container formGroupName="financialReportingPeriodDifferentThanAnnualReason">
        <snelstart-ui-textarea-form-control formControlName="value"
                                            class="me-1 custom-input-250"
                                            label="Reden voor afwijken"
                                            [rows]="3"
                                            (change)="bepaalAfwijkendRapportageJaar(); saveForm()"
        >
        </snelstart-ui-textarea-form-control>
      </ng-container>
    </div>
    <div>
      <ng-container formGroupName="financialReportingPeriodDifferentThanAnnualImpactComparatives">
        <snelstart-ui-textarea-form-control formControlName="value"
                                            class="me-1 custom-input-250"
                                            label="Effect op vergelijkende cijfers"
                                            [rows]="3"
                                            (change)="bepaalAfwijkendRapportageJaar(); saveForm()"
        >
        </snelstart-ui-textarea-form-control>
      </ng-container>
    </div>
  }
  <div>
    <ng-container formGroupName="financialReportingPeriodPreviousStartDate">
      <snelstart-ui-date-form-control formControlName="value"
                                      class="me-1 custom-input-250"
                                      label="Startdatum vorige rapportageperiode"
                                      (change)="saveForm()"
      >
      </snelstart-ui-date-form-control>
    </ng-container>
  </div>
  <div>
    <ng-container formGroupName="financialReportingPeriodPreviousEndDate">
      <snelstart-ui-date-form-control formControlName="value"
                                      class="me-1 custom-input-250"
                                      label="Einddatum vorige rapportageperiode"
                                      (change)="saveForm()"
      >
      </snelstart-ui-date-form-control>
    </ng-container>
  </div>
  <div>
    <ng-container formGroupName="basisOfPreparation">
      <snelstart-ui-select-form-control formControlName="value"
                                        class="me-1 custom-input-250"
                                        label="Type grondslag"
                                        [options]="optionsBasisOfPreparation"
                                        [disabledControl]="true"
                                        (change)="saveForm()"
      >
      </snelstart-ui-select-form-control>
    </ng-container>
  </div>
  <div>
    <ng-container formGroupName="financialStatementsDateOfPreparation">
      <snelstart-ui-date-form-control formControlName="value"
                                      class="me-1 custom-input-250"
                                      label="Datum van opmaak jaarrekening"
                                      (change)="saveForm()"
      >
      </snelstart-ui-date-form-control>
    </ng-container>
  </div>
  @if (isRechtspersoon) {
    <ng-container formGroupName="documentAdoptionStatus">
      <snelstart-ui-select-form-control formControlName="value"
                                        class="me-1 custom-input-250"
                                        label="Jaarrekening vastgesteld"
                                        [options]="optionsJaNee"
                                        (change)="saveForm()"
      >
      </snelstart-ui-select-form-control>
    </ng-container>
    @if (isDocumentAdoptionStatus) {
      <ng-container formGroupName="documentAdoptionDate">
        <snelstart-ui-date-form-control formControlName="value"
                                        class="me-1 custom-input-250"
                                        label="Datum van vaststelling"
                                        (change)="saveForm()"
        >
        </snelstart-ui-date-form-control>
      </ng-container>
    }
  }
  <div>
    <ng-container formGroupName="emailAddressFull">
      <snelstart-ui-email-form-control formControlName="value"
                                       label="E-mailadres, contactpersoon rapportage"
                                       class="me-1 custom-input-250"
                                       (change)="saveForm()">
      </snelstart-ui-email-form-control>
    </ng-container>
  </div>
</form>

